import { render, staticRenderFns } from "./EditorHeaderMobilePresentButton.vue?vue&type=template&id=5fce48f0&scoped=true&"
import script from "./EditorHeaderMobilePresentButton.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderMobilePresentButton.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeaderMobilePresentButton.vue?vue&type=style&index=0&id=5fce48f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fce48f0",
  null
  
)

export default component.exports